import { useParams } from 'react-router-dom';
import { useGetPassPurchaseQuery } from 'drycut-graphql';
import { PassDetails } from 'booking/components';
import { useDocumentTitle } from 'usehooks-ts';
import { Loader } from 'ui-components';

export function PassDetailsByUid(): JSX.Element {
  useDocumentTitle('DRYCUT - DRYPASS');

  const { uid } = useParams() as { uid: string };
  const { data, loading } = useGetPassPurchaseQuery({ variables: { uid } });

  if (loading) {
    return <Loader />;
  }

  return <PassDetails passPurchase={data?.passPurchase} />;
}
